




import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { INTEGRATION_AUTH_REQUEST } from "@/store/auth/mutation-types";
import AgroNotificationList from "@/components/agroNotificationList/AgroNotificationList.vue";

@Component({
  name: "Integration",
  components: {
    AgroNotificationList,
  },
})
export default class Integration extends Vue {
  @Prop(String)
  private username?: string | null;

  @Prop(String)
  private token?: string | null;

  get isLoading() {
    return (
      this.$store.getters["auth/requestingAuth"] ||
      this.$store.getters["user/requestingUser"]
    );
  }

  public created() {
    this.$store.dispatch(`auth/${INTEGRATION_AUTH_REQUEST}`, { token: this.token });
  }

}
